import { setupAmplitudeLocalCapture } from './providers/amplitude';
import { setupBingLocalCapture } from './providers/bing';
import { setupFacebookLocalCapture } from './providers/facebook';
import { setupGoogleAnalyticsLocalCapture } from './providers/googleAnalytics';
import { setupImpactLocalCapture } from './providers/impact';
import { setupPaypalLocalCapture } from './providers/paypal';
import { setupRedditLocalCapture } from './providers/reddit';
import { setupTikTokLocalCapture } from './providers/tiktok';

/**
 * Sets up local capture for all third-party analytics providers.
 * This ensures that analytics calls are queued before the actual scripts load.
 */
export function setupAllAnalyticsLocalCapture() {
  setupAmplitudeLocalCapture();
  setupBingLocalCapture();
  setupFacebookLocalCapture();
  setupGoogleAnalyticsLocalCapture();
  setupImpactLocalCapture();
  setupPaypalLocalCapture();
  setupRedditLocalCapture();
  setupTikTokLocalCapture();
}